import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'verifier_body_type'

export const dataPointDefinition = {
  retracedId: 'verifier_body_type',
  name: 'Verifier Body Type:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'vd-e11',
      number: 'VD-VERI-7',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'vd-e11-opt',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '',
      machineShowHide: '',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'vd_e11_opt',
      name: 'vd-e11-opt',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['vd_e11_opt'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-e11', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34620,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
